import { UpperCasePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { EmptyComponent } from '../../../../../components/datatable/components/empty/empty.component';
import { EmptyHeaderComponent } from '../../../../../components/datatable/components/empty/empty-header.component';
import { EmptySubHeaderComponent } from '../../../../../components/datatable/components/empty/empty-sub-header.component';
import { HrefDirective } from '../../../../../directives/href/href.directive';
import { IconComponent } from '../../../../../components/icon/icon.component';
import { NotificationComponent } from '../../../../../components/notification/notification.component';
import { TranslatePipe } from '../../../../../pipes/translate.pipe';
import { IfFeatureDirective } from '../../../../if-feature/if-feature.directive';
import { IfNoFeatureDirective } from '../../../../if-feature/if-no-feature.directive';
import { BuySellButtonsComponent } from '../../../buy-sell/buy-sell-buttons.component';
import { QuoteTemplate } from '../../domain/quote-template.enum';
import { TradeInfo } from '../../../../../domain/buy-sell.domain';
import { SecuritySymbol } from '../../../../../domain/symbol.domain';

@Component({
  selector: 'td-wb-detailed-quote-message',
  templateUrl: 'detailed-quote-message.component.html',
  styleUrls: ['detailed-quote-message.component.scss'],
  imports: [
    UpperCasePipe,
    TranslatePipe,
    TranslateDirective,
    NotificationComponent,
    IfNoFeatureDirective,
    EmptyComponent,
    EmptyHeaderComponent,
    EmptySubHeaderComponent,
    IfFeatureDirective,
    IconComponent,
    HrefDirective,
    BuySellButtonsComponent
  ]
})
export class DetailedQuoteMessageComponent {
  readonly template = input<QuoteTemplate>(undefined);
  readonly symbol = input<SecuritySymbol>(undefined);
  readonly tradeInfo = input<TradeInfo>(undefined);

  readonly hideHeader = input<boolean>(false);
}
